<template>
  <div 
    class="completionist-card text-white shadow-md rounded-lg font-medium overflow-hidden text-12px"
    :class="{
      'bg-challenge-blue': is_correct == null,
      'bg-challenge-orange': is_correct != null && !is_correct,
      'bg-challenge-green': is_correct != null && is_correct
    }"
  >
    <div class="px-3 py-x1 flex flex-row justify-between items-center">
      <div class="flex flex-row gap-3 items-center">
        <div>
          <Icon 
            v-if="isCompleted"
            class="text-24px"
            :icon="'mdi:check-circle'" 
            :style="{
              width: '36px',
              height: '36px'
            }"
          />
          <Icon 
            v-else
            class="text-24px"
            :icon="'mdi:close-circle'" 
            :style="{
              width: '36px',
              height: '36px'
            }"
          />
        </div>
        <div class="flex flex-col gap-1">
          <p v-html="status_label"></p>
        </div>
      </div>
      <div>
        <a 
          v-if="!isCompleted"
          :href="href" 
          :target="linkTarget"
          rel="noreferrer nofollow"
        >
          <button 
            class="bg-black text-white px-6 py-x0.5 rounded-md text-14px font-semibold border-b-1 border-r-1 border-black hover:border-white" 
            v-html="button_label"
          ></button>
        </a>
      </div>
    </div>
    <div class="px-3 py-4 bg-white text-black text-14px">
      <p v-html="title"></p>
    </div>
    <div class="px-3 py-x1 text-center relative">
      <div 
        v-if="peer_correct"
        class="absolute inset-y-0 right-0 h-full bg-black"
        :style="{
          width: `${ 100 - parseInt(peer_correct) }%`
        }"
      ></div>
      <p v-if="!isNew && peer_correct" class="relative flex flex-row justify-center items-center gap-x0.5">
        <span class="text-20px font-semibold" v-html="peer_correct + '%'"></span>
        <span v-html="peer_correct_label"></span>
      </p>
    </div>
  </div>
</template>

<script setup>
import { defineProps, computed } from 'vue'
import { Icon } from '@iconify/vue'

const props = defineProps({
  caseNumber: {
    type: [String, Number],
    required: true
  },
  data: {
    type: Object,
    required: true
  }
})

const title = computed(() => props.data?.title)
const href = computed(() => props.data?.href)
const status = computed(() => props.data?.status)
const is_correct = computed(() => props.data?.is_correct)
const peer_correct = computed(() => props.data?.peer_correct)
const cta_label = computed(() => props.data?.cta_label)

const isNew = computed(() => status.value === 'new')
const isInProgress = computed(() => status.value === 'started')
const isCompleted = computed(() => status.value === 'completed')
const isChallenge = computed(() => status.value === 'challenge')

const status_label = computed(() => {
  if (props.data?.status_label) return props.data?.status_label
  if (isInProgress.value) return 'In Progress'
  if (isCompleted.value) return 'Completed'
  return 'Not Started'
})
const peer_correct_label = computed(() => {
  return ' of your peers answered correctly'
})
const button_label = computed(() => {
  return cta_label.value
    ? cta_label.value
    : isChallenge.value
      ? 'Challenge' 
      : isInProgress.value
      ? 'See Peers'
      : 'Start'
})

const linkTarget = computed(() => {
  if (href.value && href.value.includes('poc-test-module')) {
    return '_blank'
  }
  return null
})

</script>

<style scoped>
.completionist-card {
  width: 100%;
  height: 100%;
}
</style>